import { Archive, Cart, Folder, Tools } from 'iconoir-react';
import { ReactElement } from 'react';

interface ResultRowIconStyle {
  icon: ReactElement;
  className: string;
}

const RESULT_ROW_ICON_STYLE_BY_NAME: Record<string, ResultRowIconStyle> = {
  Folder: {
    icon: <Folder />,
    className: 'bg-surface-accent-12-default stext-accent-12-default',
  },
  Order: {
    icon: <Cart />,
    className: 'bg-surface-accent-01-default stext-accent-01-default',
  },
  Stock: {
    icon: <Archive />,
    className: 'bg-surface-accent-06-default stext-accent-06-default',
  },
  Sparepart: {
    icon: <Tools />,
    className: 'bg-surface-accent-13-default stext-accent-13-default',
  },
};

const DEFAULT_RESULT_ROW_ICON_STYLE = RESULT_ROW_ICON_STYLE_BY_NAME.Folder;

export const getResultRowIconStyle = (icon?: string): ResultRowIconStyle =>
  RESULT_ROW_ICON_STYLE_BY_NAME[icon ?? ''] ?? DEFAULT_RESULT_ROW_ICON_STYLE;
